import { PlanStatus, type SupportedFeature } from "@src/gql/graphql";
import { useMemo } from "react";
import { useMyPlan } from "../queries/fetch-plan";
import { type FeatureStats, isFeatureEnabled } from "./base";

export interface FeatureResult {
	feature: SupportedFeature;
	enabled: boolean;
	stats?: FeatureStats;
}

export const useAvailableFeatures = (options?: { shareKey?: string }) => {
	const { data: plan } = useMyPlan(options);

	const availableFeatures = useMemo(() => {
		const features = plan?.features ?? [];
		const baseEnabled =
			plan?.status === PlanStatus.Active ||
			plan?.status === PlanStatus.InTrial ||
			plan?.status === PlanStatus.Cancelled;

		return features.map((feature) => {
			const { enabled: featureEnabled, stats: featureStats } =
				isFeatureEnabled(feature);

			return {
				feature: feature.feature,
				enabled: baseEnabled && featureEnabled,
				stats: featureStats,
			} satisfies FeatureResult;
		});
	}, [plan?.features, plan?.status]);

	return { availableFeatures, plan };
};
